<template>
  <div>
    <!-- header start -->
    <van-nav-bar
        title="忌日与诞辰"
        fixed
        :z-index="99"
        left-arrow
        @click-left="onClickLeft"
        :border="false"
     />
    <div class="navBarSpace"></div>
    <!-- header end -->
    
    <van-tabs ref="tabbb" sticky animated swipeable offset-top="46" @change="onChange"  title-active-color="#fff" title-inactive-color="#f2f2f2" background="#24a378" color="#fff" :border="false">
      <van-tab title="今日忌日"  >
        <birthday_death_list></birthday_death_list>

        <!-- 双人馆 -->
        <!-- <router-link to="/MemorialHall" class="hall-item">
          <van-swipe class="my-swipe" :loop="false" indicator-color="orange">
            <van-swipe-item v-for="item in 2" :key="item.id">
              <div class="hall-list">
                <div class="bd">
                  <h2 class="sz-name">原广州军区空军政治委员张振先同志纪念馆</h2>
                  <div class="sz-des">
                    <P>逝者:剥落</P>
                    <P>馆号: TT1582469852</P>
                    <P>建馆人:天使</P>
                    <P>创建时间: 2015- -12-10</P>
                    <P>访问量: 184563</P>
                  </div>
                </div>
                <div class="ft">
                  <img src="https://img.yzcdn.cn/vant/cat.jpeg" class="avatar">
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <img src="@/assets/images/double_tag_icon.png" class="double-tag" />
        </router-link> -->
        <!-- 单人馆 -->
        <!-- <router-link to="/MemorialHall" v-for="item in 4" :key="item.id" class="hall-item">
          <div class="hall-list">
            <div class="bd">
              <h2 class="sz-name">原广州军区空军政治委员张振先同志纪念馆</h2>
              <div class="sz-des">
                <P>逝者:剥落</P>
                <P>馆号: TT1582469852</P>
                <P>建馆人:天使</P>
                <P>创建时间: 2015-12-10</P>
                <P>访问量: 184563</P>
              </div>
            </div>
            <div class="ft">
              <img src="https://img.yzcdn.cn/vant/cat.jpeg" class="avatar">
            </div>
          </div>
        </router-link> -->
      </van-tab>
      <van-tab title="今日诞辰" >
        <birthday_birthday_list></birthday_birthday_list>
        <!-- 双人馆 -->
        <!-- <router-link to="/MemorialHall" class="hall-item">
          <van-swipe class="my-swipe" :loop="false" indicator-color="orange">
            <van-swipe-item v-for="item in 2" :key="item.id">
              <div class="hall-list">
                <div class="bd">
                  <h2 class="sz-name">原广州军区空军政治委员张振先同志纪念馆</h2>
                  <div class="sz-des">
                    <P>逝者:剥落</P>
                    <P>馆号: TT1582469852</P>
                    <P>建馆人:天使</P>
                    <P>创建时间: 2015- -12-10</P>
                    <P>访问量: 184563</P>
                  </div>
                </div>
                <div class="ft">
                  <img src="https://img.yzcdn.cn/vant/cat.jpeg" class="avatar">
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <img src="@/assets/images/double_tag_icon.png" class="double-tag" />
        </router-link> -->
        <!-- 单人馆 -->
        <!-- <router-link to="/MemorialHall" v-for="item in 4" :key="item.id" class="hall-item">
          <div class="hall-list">
            <div class="bd">
              <h2 class="sz-name">原广州军区空军政治委员张振先同志纪念馆</h2>
              <div class="sz-des">
                <P>逝者:剥落</P>
                <P>馆号: TT1582469852</P>
                <P>建馆人:天使</P>
                <P>创建时间: 2015-12-10</P>
                <P>访问量: 184563</P>
              </div>
            </div>
            <div class="ft">
              <img src="https://img.yzcdn.cn/vant/cat.jpeg" class="avatar">
            </div>
          </div>
        </router-link> -->
      </van-tab>
    </van-tabs>
    
    
  </div>
</template>

<script>
  import birthday_birthday_list from "@/components/birthday_birthday_list";
  import birthday_death_list from "@/components/birthday_death_list";
  export default {
    data() {
      return {
        map : {},
      }
    },
    components: {
      birthday_birthday_list,
      birthday_death_list
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      onChange(index,name){
        var that = this;
        var key = index == 0 ? 1: 0;
        var top = document.documentElement.scrollTop || document.body.scrollTop;
        this.map[key] = top;
        
        this.$nextTick(() => {
            window.scrollTo(0, that.map[index]);
        })
      }
    },
  }
</script>

<style scoped>

</style>
